import React from "react";
import { SuppressedCount } from "../../../api/playAdminApi";

/**
 * The ONLY renderer for n<5-suppressed counts. Numbers render as numbers;
 * the literal string "<5" renders VERBATIM with an explanatory tooltip.
 * NO arithmetic is ever performed on a SuppressedCount (no bar math, no
 * totals, no NaN) — suppression is a privacy device, not a zero.
 */
export const SuppressedCountValue: React.FC<{ value: SuppressedCount }> = ({
  value,
}) =>
  value === "<5" ? (
    <span
      className="text-slate-500"
      title="Shown as <5 to protect individual staff privacy in small groups"
      data-testid="suppressed-count"
    >
      {"<5"}
    </span>
  ) : (
    <span>{value}</span>
  );

/** Bar width helper that REFUSES suppressed values (returns 0-width). */
export const numericOrZero = (value: SuppressedCount): number =>
  typeof value === "number" ? value : 0;
